import React from 'react';
import { Skeleton } from 'antd';
import Button from '../../../../../components/Button';
import CountOfTotal from '../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import SendMessageService from '../../../../../containers/app/common/SendMessageService';
import Panel from '../../../../../components/outline/Panel';
import InfoForm from '../../../../../components/outline/InfoForm';
import BaseForm from '../../../../../components/form/BaseForm';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import SwitchForm from '../../../../../components/form/SwitchForm';
import { setDash, setPhoneFormat, setTimeFormat } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import { setDateFormat } from '../../../../../lib/moment';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import columns from '../../../qna/detail/CsQnaDetailInfo/columns';
import {
  CS_QNA_DETAIL_USERS_OTHER_TABLE_EMPTY_TEXT,
  CS_QNA_STATUS,
  CS_QNA_STATUS_TEXT,
  FORMAT_TIME_REPLY_DATE,
  QNA_RESPONSE_BUTTON_TEXT,
  MAXIMUM_NUMBER_OF_QNA_ANSWER_TEXT,
  MAXIMUM_NUMBER_OF_QNA_MEMO_TEXT,
  AI_REPLY_KEYWORD_MAX_LENGTH,
} from '../../../../../constants/service/app/csQnaConstants';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { ORDER_ITEM_STATUS_TEXT } from '../../../../../constants/service/app/orderConstants';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import { useQnaAutoReply } from '../../../../../hooks/qna/useQnaAutoReply';
import './CsQnaDetailInfo.scss';

const CsInquiryDetailInfo = (props) => {
  const { form, qnaInfo, productInfo, setData, getUsersOtherQnaList, changeQnaStatus, onReply, changeQnaSecret } =
    props;
  const {
    createDate,
    answerDate,
    timeReply,
    userAccount,
    userId,
    userName,
    memo,
    status,
    question,
    answer,
    userEmail,
    userCellPhone,
    usersOtherQna,
    replyAuthor,
    orderItemId,
    orderItemStatus,
    isSecret,
  } = qnaInfo;
  const { list, pagination, summary } = usersOtherQna;

  // AI 답변 자동완성 훅
  const { generate, isLoading } = useQnaAutoReply();

  const handleGenerateAIReply = async () => {
    const keywords = form.getFieldValue('aiKeywords') || '';

    const reply = await generate({
      question,
      productName: productInfo?.productName,
      keywords,
      userName,
    });

    if (reply) {
      // AI 생성 답변과 키워드 저장 (슬랙 알림 및 피드백용)
      setData({
        path: ['csQnaDetail', 'qnaInfo', 'aiGeneratedAnswer'],
        value: reply,
      });
      setData({
        path: ['csQnaDetail', 'qnaInfo', 'aiKeywords'],
        value: keywords,
      });
      setData({
        path: ['csQnaDetail', 'qnaInfo', 'answer'],
        value: reply,
      });
      form.setFieldsValue({ answer: reply });
    }
  };

  return (
    <Panel className="cs-qna-detail-info">
      <div className="panel-header">
        <div className="title">문의 정보</div>

        <div className="button-list">
          <SwitchForm label="비밀글 여부" checked={isSecret} onChange={(isSecret) => changeQnaSecret(isSecret)} />

          <SwitchForm
            label="노출 여부"
            checked={status === CS_QNA_STATUS.SUBMIT}
            onChange={(active) => changeQnaStatus(active)}
          />

          {status === CS_QNA_STATUS.SUBMIT ? (
            <Button isRadius color="primary" onClick={() => onReply()} text={QNA_RESPONSE_BUTTON_TEXT[!!timeReply]} />
          ) : null}
        </div>
      </div>

      <div className="panel-body">
        <div className="users-other-qna-list">
          <div className="title">이 사람의 다른 문의 내역</div>

          <TableWithSummary
            data={list}
            totalCnt={summary.totalCnt}
            initialOption={{ pagination: LIST_PAGINATION_MODEL }}
            isStriped={true}
            emptyText={CS_QNA_DETAIL_USERS_OTHER_TABLE_EMPTY_TEXT}
            showPagination
            pagination={pagination}
            getList={getUsersOtherQnaList}
            columns={(utils) =>
              columns({
                ...utils,
              })
            }
          />
        </div>

        <div className="qna-section">
          <div className="qna-info">
            <InfoForm className="qna-info-form">
              {/*문의 접수일*/}
              <BaseForm label="문의 접수일" content={setDateFormat(createDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)} />

              {/*답변 일자*/}
              <BaseForm label="답변 일자" content={setDateFormat(answerDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)} />

              {/*주문여부*/}
              <BaseForm
                label="주문여부"
                content={<OpenOrderItemDetail text={orderItemId} orderItemId={orderItemId} />}
              />

              {/*주문상태*/}
              <BaseForm label="주문상태" content={ORDER_ITEM_STATUS_TEXT[orderItemStatus]} />

              {/*문의자 ID*/}
              <BaseForm label="문의자 ID" content={<OpenUserDetail text={userAccount} userId={userId} />} />

              {/*문의자명*/}
              <BaseForm label="문의자명" content={setDash(userName)} />

              {/*문의자 이메일*/}
              <BaseForm label="문의자 이메일" content={setDash(userEmail)} />

              {/*문의자 전화번호*/}
              <BaseForm
                label="문의자 핸드폰 번호"
                content={
                  <SendMessageService
                    text={setPhoneFormat(userCellPhone)}
                    memberType={AMONDZ_MEMBER_TYPE.USER}
                    targetId={userId}
                  />
                }
              />
            </InfoForm>
          </div>

          <div className="qna-info">
            <InfoForm className="qna-info-form">
              {/*상태*/}
              <BaseForm label="상태" content={CS_QNA_STATUS_TEXT[status]} />

              {/*답변까지 걸린 시간*/}
              <BaseForm label="답변까지 걸린 시간" content={setTimeFormat(timeReply, FORMAT_TIME_REPLY_DATE)} />

              {/*문의내용*/}
              <BaseForm className="question" label="문의내용" content={setDash(question)} />

              {/*AI 추천 답변 생성*/}
              <TextAreaForm
                form={form}
                label={
                  <span>
                    <span>AI 추천 답변 생성</span>
                    <CountOfTotal content={form.getFieldValue('aiKeywords')} maxCnt={AI_REPLY_KEYWORD_MAX_LENGTH} />
                  </span>
                }
                name="aiKeywords"
                initialValue=""
                maxLength={AI_REPLY_KEYWORD_MAX_LENGTH}
                placeholder="답변에 포함할 키워드를 입력하세요 (예: 배송 지연 사과, 교환 안내)"
                autoSize={{ minRows: 3, maxRows: 10 }}
                isEditable={status === CS_QNA_STATUS.SUBMIT}
                subContent={
                  <div className="ai-reply-button-wrapper">
                    <Button
                      text={isLoading ? 'AI 답변 생성 중...' : 'AI 답변 자동완성'}
                      color="primary"
                      onClick={handleGenerateAIReply}
                      disabled={isLoading}
                      isRadius
                    />
                  </div>
                }
              />

              {/*답변*/}
              {isLoading ? (
                <BaseForm label="답변" content={<Skeleton active paragraph={{ rows: 4 }} />} />
              ) : (
                <TextAreaForm
                  form={form}
                  label={
                    <span>
                      <span>답변</span>
                      <CountOfTotal content={answer} maxCnt={MAXIMUM_NUMBER_OF_QNA_ANSWER_TEXT} />
                    </span>
                  }
                  rules={[formRequiredRules(true, '답변을 작성해주세요.')]}
                  isEditable={status === CS_QNA_STATUS.SUBMIT}
                  initialValue={answer}
                  maxLength={MAXIMUM_NUMBER_OF_QNA_ANSWER_TEXT}
                  onChange={(value) =>
                    setData({
                      path: ['csQnaDetail', 'qnaInfo', 'answer'],
                      value,
                    })
                  }
                  name="answer"
                  autoSize={{ minRows: 4, maxRows: 50 }}
                />
              )}

              {/*메모*/}
              <TextAreaForm
                form={form}
                label={
                  <span>
                    <span>메모</span>
                    <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_QNA_MEMO_TEXT} />
                  </span>
                }
                rules={[formRequiredRules(true, '메모를 작성해주세요.')]}
                isEditable={status === CS_QNA_STATUS.SUBMIT}
                initialValue={memo}
                maxLength={MAXIMUM_NUMBER_OF_QNA_MEMO_TEXT}
                onChange={(value) =>
                  setData({
                    path: ['csQnaDetail', 'qnaInfo', 'memo'],
                    value,
                  })
                }
                name="memo"
                autoSize={{ minRows: 4, maxRows: 50 }}
              />

              {/*답변 작성자*/}
              {timeReply ? <BaseForm label="답변 작성자" content={replyAuthor || '판매자'} /> : null}
            </InfoForm>
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default CsInquiryDetailInfo;
